import { Component, Input, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'app-search-input',
  standalone: true,
  imports: [CommonModule, FlexLayoutModule, MatFormFieldModule, MatInputModule, MatIconModule],
  template: `
    <mat-form-field appearance="outline" fxFill>
      <mat-icon matPrefix>search</mat-icon>
      <mat-label>Pesquisar</mat-label>
      <input matInput type="search" [placeholder]="placeholder" (keyup)="onKeyup($event)" #input />
    </mat-form-field>
  `
})
export class SearchInputComponent implements AfterViewInit {
  @Input() placeholder = 'Digite e pressione ENTER para pesquisar'
  @Output() search = new EventEmitter<Event>()
  @ViewChild('input', { static: true }) inputRef!: ElementRef<HTMLInputElement>

  ngAfterViewInit(): void {
    // inputRef disponível após view init
  }

  onKeyup(event: Event): void {
    this.search.emit(event)
  }

  get value(): string {
    return this.inputRef?.nativeElement?.value || ''
  }
}
